/**
 * Centralized API Configuration
 * 
 * This file provides the single source of truth for all API URLs in the application.
 * All API endpoints should be accessed through this configuration.
 * 
 * Usage:
 *   import { API_BASE } from './shared/api/config';
 *   // or
 *   import { apiFetch } from './shared/api/apiFetch';
 */

// Try to get VITE_API_BASE_URL first (Vite), then REACT_APP_API_URL (CRA), then fallback to ''
const apiBaseUrl = import.meta?.env?.VITE_API_BASE_URL || 
                    process.env?.REACT_APP_API_URL || 
                    '';

export const API_BASE = apiBaseUrl;

// Export commonly used API paths
export const API_PATHS = {
  // Auth endpoints
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/auth/logout',
  AUTH_REFRESH: '/auth/refresh',
  AUTH_VERIFY: '/auth/verify',
  
  // Candidate endpoints
  CANDIDATE_GET_ALL: '/candidate/get-all-candidates',
  CANDIDATE_SEARCH: '/candidate/search-candidates',
  CANDIDATE_SAVE: '/candidate/save-candidate-data',
  CANDIDATE_GET_CURRENT: '/candidate/get-current-candidate-for-certificate',
  CANDIDATE_GET_FOR_DROPDOWN: '/candidate/get-candidates-for-dropdown',
  
  // Certificate endpoints
  CERTIFICATE_SELECTIONS: '/certificate/get-certificate-selections-for-receipt',
  CERTIFICATE_UPDATE_STATUS: '/certificate/update-certificate-status',
  CERTIFICATE_DELETE: '/certificate/delete-certificate-selection',
  
  // Bookkeeping endpoints
  BOOKKEEPING_COMPANY_ACCOUNTS: '/api/bookkeeping/get-company-accounts',
  BOOKKEEPING_ALL_COMPANIES: '/api/bookkeeping/get-all-companies',
  BOOKKEEPING_ALL_VENDORS: '/api/bookkeeping/get-all-vendors',
  BOOKKEEPING_B2B_CUSTOMERS: '/api/bookkeeping/get-b2b-customers',
  BOOKKEEPING_RECEIPT: '/api/bookkeeping/receipt-amount-received',
  
  // File endpoints
  FILE_UPLOAD: '/upload',
  FILE_SAVE_INVOICE_IMAGE: '/api/files/save-invoice-image',
  FILE_GET_INVOICE_IMAGE: '/api/files/get-invoice-image',
  
  // Master data endpoints
  MASTER_COMPANY: '/master/company',
  MASTER_B2B: '/master/b2b',
  MASTER_VENDOR: '/master/vendor',
  MASTER_COURSE: '/master/course',
};

export default API_BASE;
